<template>
  <b2b-input-layout v-bind="$_layoutBind" :focused="focused" class="b2b-input">
    <template #prepend>
      <slot name="prepend" />
    </template>

    <input
      v-model="$_model"
      v-bind="$_inputBind"
      ref="input"
      :multiple="multiple"
      :required="required"
      @click.stop="$_onClick"
      @focus="focused = true"
      @blur="focused = false"
      :maxlength="maxlength"
      :pattern="patternRegexInput"
      :oninvalid="$_setCustomValidity()"
      oninput="setCustomValidity('')"
      @keypress="$_inputKeyPress($event)"
    />

    <template>
      <slot name="hint" />
    </template>

    <div v-show="clearable && $_model" class="b2b-input__clear" @click.stop="$_onClickClear">
      <x-icon size="24" />
    </div>

    <template #append>
      <slot name="append" />
    </template>
  </b2b-input-layout>
</template>

<script>
import { XIcon } from 'vue-feather-icons';

import InputMixin from '../../../mixins/components/input-mixin';
import ModelMixin from '../../../mixins/base/model-mixin';

import B2bInputLayout from './b2b-input-layout.vue';

export default {
  name: 'b2b-input',

  mixins: [
    InputMixin(),
    ModelMixin(String),
  ],

  components: {
    B2bInputLayout,
    XIcon,
  },

  props: {
    clearable: Boolean,
    multiple: Boolean,
    textInputInvalid: {
      type: String,
      default: '',
    },
    patternRegexInput: {
      type: String,
      default: '.*',
    },
    maxlength: {
      type: Number,
      default: 255,
    },
  },

  data() {
    return {
      focused: false,
    };
  },

  methods: {
    focus() {
      this.$refs.input.focus();
    },

    $_onClick($event) {
      this.$emit('click', $event);
    },

    $_onClickClear($event) {
      this.$_model = '';
      this.$emit('click:clear', $event);
    },

    $_setCustomValidity() {
      return `setCustomValidity('${this.textInputInvalid}')`;
    },

    $_inputKeyPress($event) {
      this.$emit('keypress', $event);
    },
  },
};
</script>

<style lang="scss">
.b2b-input {
  &__clear {
    width: 48px;
    height: 48px;

    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
  }

  > input {
    color: $easyColorWhite;
    border-radius: $easyBorderRadius;
    background-color: transparent;
    background-clip: padding-box;
    -webkit-text-fill-color: $easyColorWhite;
    caret-color: $easyColorWhite;

    &::placeholder {
      opacity: 0;
      color: transparent;
    }

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      border-radius: $easyBorderRadius;
      -webkit-text-fill-color: $easyColorWhite;
      -webkit-box-shadow: 0 0 0 1000px transparent inset;
      box-shadow: 0 0 0 1000px transparent inset;
      transition: background-color 9999s ease-out 0s;
    }

    &[type=file] {
      padding-top: 12px;
    }

    &[type=color] {
      &::-webkit-color-swatch-wrapper {
        padding: 16px 0;
      }
      &::-webkit-color-swatch {
        border: none;
        border-radius: 4px;
      }

      &::-moz-color-swatch {
        border: none;
        height: 16px;
        border-radius: 4px;
      }
    }
  }

  .b2b-input-layout__border-left {
    border: $easyBorder !important;
    border-right: 0 !important;
    border-color: $colorMainSecondary !important;
    border-top-left-radius: $easyBorderRadius;
    border-bottom-left-radius: $easyBorderRadius;
  }

  .b2b-input-layout__border-label {
    border-top: $easyBorder !important;
    border-bottom: $easyBorder !important;
    border-color: $colorMainSecondary !important;
  }

  .b2b-input-layout__border-right {
    border: $easyBorder !important;
    border-left: 0 !important;
    border-color: $colorMainSecondary !important;
    border-top-right-radius: $easyBorderRadius;
    border-bottom-right-radius: $easyBorderRadius;
  }

  &.b2b-input-layout--focused,
  &.b2b-input-layout--has-value {
    .b2b-input-layout__border-label {
      border-top: 0 !important;
    }
  }
}
</style>
